import { Navigate, useParams } from "react-router-dom";

/** Old Schedule review links land on the Scheduling page. */
export default function ScheduleReviewRedirect() {
  const { eventId } = useParams<{ eventId: string }>();
  return <Navigate to={`/admin-dashboard/events/${eventId}/scheduling`} replace />;
}
